import React from 'react';
import { useObservable } from 'react-use-observable';

import { Card, Flex, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { EHintPath } from 'v2/interfaces/hint';
import { hintFactory } from 'v2/services/hint';

export type hintTypes = 'digital' | 'physical' | 'service';

interface IHint {
  type: hintTypes;
  can?: boolean;
  cant?: boolean;
}

const Hints = ({ type, can, cant }: IHint) => {
  const [hints] = useObservable(() => hintFactory.getHints(EHintPath.NEW_PRODUCT), []);
  if (!hints?.length) return null;
  let hintsByType = hints.filter(h => h.link === type);
  if (can) hintsByType = hintsByType.filter(h => h.label === 'hint-can');
  if (cant) hintsByType = hintsByType.filter(h => h.label === 'hint-cant');
  if (!hintsByType.length) return null;
  return (
    <Card size='small'>
      <ul className='m-0 list-none p-0'>
        {hintsByType.map(h => {
          if (h.name === 'title') {
            return (
              <li key={h.hint} className='px-4 py-2'>
                <Typography.Text strong>{h.hint}</Typography.Text>
              </li>
            );
          }

          return (
            <li key={h.hint} className='px-4 py-2'>
              <Flex align='start' gap='middle'>
                <Typography.Text className='min-w-5'>
                  {h.label === 'hint-can' && (
                    <Typography.Text type='success'>
                      <Icon.CircleCheck  />
                    </Typography.Text>
                  )}
                  {h.label === 'hint-cant' && (
                    <Typography.Text type='danger'>
                      <Icon.CircleX  />
                    </Typography.Text>
                  )}
                </Typography.Text>
                <Typography.Text>{h.hint}</Typography.Text>
              </Flex>
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default Hints;
